export const productCategories = {
  "Eyeglasses": "eyeframe",
  "Zero Powered Glasses": "non_powered_reading",
  "Powered Sunglasses": "powered_sunglasses",
  "Zero Powered Sunglasses": "sunglasses",
  "Contact Lenses": "contact_lens",
  "Accessories": "accessories_revenue"
};

export const disableBasedOnCategory = {
    "": {
        "frame": false,
        "lens": false,
        "other": false
    },
    "Eyeglasses": {
        "frame": false,
        "lens": false,
        "other": true
    },
    "Zero Powered Glasses": {
        "frame": false,
        "lens": false,
        "other": true
    },
    "Powered Sunglasses": {
        "frame": false,
        "lens": false,
        "other": true
    },
    "Zero Powered Sunglasses": {
        "frame": false,
        "lens": false,
        "other": true
    },
    "Contact Lenses": {
        "frame": true,
        "lens": false,
        "other": true
    },
    "Accessories": {
        "frame": true,
        "lens": true,
        "other": false
    }
}

export const lensTypes = [
    "Single Vision",
    "Bifocal",
    "Progressive",
    "Spherical",
    "Toric",
    "Multifocal",
    "Color lens",
    "Specialty"
];

export const tabNameToRoute = {
  "ACTION_PENDING": "/vision/actionPending",
  "PAYMENT_PENDING": "/vision/paymentPending",
  "PICKED": "/vision/pickedForManufacturing",
  "MANUFACTURING": "/vision/readyForManufacturing",
  "OUT_FOR_DELIVERY": "/vision/readyForPickup",
  "DELIVERED": "/vision/delivered",
  "CANCELLED": "/vision/cancelled",
};

export const compulsoryFieldBasedOnCategory = {
    lensMRP: ["Contact Lenses"],
    otherMRP: ["Accessories"]
}

export const visionContractId = 14734
export const WAPIGetFileURL = "https://www.medibuddy.in/WAPI/GetFile";
export const coreNodeFileURL = "https://corenode-prod.medibuddy.in/v1/getSignedUrl/download"